import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { SessionStorageService } from "app/shared/services/session-storage.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "app/App Store/state";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";
import { ViewTopicsComponent } from "../view-topics/view-topics.component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import moment from "moment";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("name") inputName;
  referenceForm: FormGroup;
  reference_id: any;
  // reference_model = {
  //   _id: '',
  //   refId: '',
  //   name: '',
  //   links: '',
  //   description: '',
  //   IP: '',
  //   notes: '',
  //   admin_notes: ''
  // }
  students_array = [];
  student_obj = {
    student_id: "",
    enrollment_id: "",
    course_id: "",
    session_id: "",
    topic_id: [],
  };
  class_model = {
    instructor: "",
    title: "",
    date: "",
    start_time: "",
    end_time: "",
    notes: "",
    type: "",
    status: "",
    admin_notes: "",
    zoom_link: "",
    students: [],
    project_tag: null,
    references: [],
    pattern_schedule: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      sunday: false,
    },
  };
  select_student = null;
  enrollment_list: any = [];
  select_enrollment = null;
  select_topic = null;
  select_session = null;
  select_course = null;
  topic_list: any = [];
  session_list: any = [];
  radio_button: any = null;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue = "";
  isFilter: boolean = false;
  // column header
  public columns = [
    { name: " Topic Name", prop: "topic" },
    { name: "Date", prop: "date" },
    { name: "Time", prop: "time" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any;
  main_menu_id: any;
  activeTab: any;
  class_id: any;
  showDatePopup = false;
  showDatePopup1 = false;
  fromDate: Date | string;
  toDate: Date | string;
  selectedClassId: string;
  guideline_data: any;
  // editingDateRow: any = null;
  editingDateRow: string | null = null;
  editingProjectTagRow: string | null = null;
  projectTagList: any[] = [];
  project_tags_list = [];
  project_tags_tagcat_id = "685971ad7bf67c03258f6740";
  editingProjectRow: any = null;
  selectedProjectTagId: string;
  selectedProjectTag: any = {};
  editingTimeRow: string | null = null;
  editedStartTime: string = "";
  editedEndTime: string = "";
  editingNotesRow: string | null = null;
  editedNotes: string = "";
  editingAdminNotesRow: string | null = null;
  editedAdminNotes: string = "";
  editingZoomLinkRow: string | null = null;
  editedZoomLink: string = "";
  editingReferenceRow: string | null = null;
  isStudentSubmit: boolean = false;
  selectedReference: any;
  selectedRef: string[] = [];
  referenceList = [];
  student_list: any = [];
  course_list: any = [];
  selectedClassIdForRef: string = ""; // store class id temporarily
  reference_model: {
    _id: string;
    name: string;
    links: string;
    IP: string;
    description: string;
    notes: string;
    admin_notes: string;
    class_id?: string;
  } = {
      _id: "",
      name: "",
      links: "",
      IP: "",
      description: "",
      notes: "",
      admin_notes: "",
    };
  ipAddress: any;
  pageNumberSubscription: Subscription;
  status_list = [
    { id: "pattern", name: "Pattern" },
    { id: "today", name: "Today" },
    { id: "upcoming", name: "Upcoming" },
    { id: "past", name: "Past" },
  ];
  type_list = [{ name: "batch" }, { name: "student" }];
  select_classType = "batch";
  showDeactivated: boolean = false;
  searchVal: string = "";
  constructor(
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private activerouter: ActivatedRoute,
    private route: Router,
    private store: Store<AppState>,
    private formBuilder: FormBuilder
  ) {
    this.user_role = JSON.parse(localStorage.getItem("user"));
    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter((item) => item.key == "Classes");
    this.guideline_data = key_data[0]?._id;

    this.activerouter.queryParamMap.subscribe((params) => {
      // this.activeClassTab("today")
      this.activeTab = params.get("status");
      if (!this.activeTab) {
        this.activeTab = "today";
        this.activeClassTab(this.activeTab);
      }
      let page = +params.get("page");
      this.setPage(page);
    });
    this.pageNumberSubscription = this.store
      .select((state) => state.page.pageNumber)
      .subscribe((pageNumber) => {
        this.page.pageNumber = pageNumber;
        if (pageNumber !== undefined) {
          this.page.pageNumber = pageNumber - 1;
        }
        if (pageNumber === 0) this.page.pageNumber = 0;
      });
  }

  startEditingReference(row: any) {
    this.editingReferenceRow = row._id;
    this.selectedReference = row.refrences?._id || null;
  }

  saveReference(row: any) {
    const payload = {
      class_id: row._id,
      reference_id: this.selectedReference,
    };

    this.apiService.updateClassReference(row._id, payload).subscribe(
      () => {
        this.toastr.success("Reference updated");
        this.editingReferenceRow = null;
        this.setAndGetClassByStatus(); // Refresh class list
      },
      () => this.toastr.error("Failed to update reference")
    );
  }

  newReference = { name: "", links: "" };

  addReference(modal: any) {
    this.apiService.createReference(this.newReference).subscribe(
      (res: any) => {
        this.referenceList.push(res.data);
        this.selectedReference = res.data._id;
        this.toastr.success("Reference added");
        modal.close();
      },
      () => this.toastr.error("Failed to add reference")
    );
  }
  getRefId(event) {
    if (!this.class_id) {
      this.selectedRef;
      this.class_model.references = event;
    }
    if (this.class_id) {
      this.class_model.references = event;
      let data = this.class_model.references.filter((obj) => !("_id" in obj));
      if (data) {
        this.class_model.references = data;
        const newValues = event.filter(
          (value) =>
            !this.class_model.references.some((obj) => obj._id === value._id)
        );
        this.class_model.references.push(...newValues);
      }
    }
  }
  enableDateEdit(row: any) {
    this.editingDateRow = { ...row };
  }
  // @ViewChild('myModal2') myModal2: TemplateRef<any>;
  @ViewChild("myModal") myModal: TemplateRef<any>;
  @ViewChild("myModal2") myModal2: TemplateRef<any>;
  @ViewChild("studentModal", { static: true }) studentModal: TemplateRef<any>;
  // @ViewChild('studentModal', { static: true }) studentModal: any;
  editRef(ref: any) {
    this.reference_model = { ...ref };
    // Populate form with existing values
    if (this.referenceForm) {
      this.referenceForm.patchValue({
        name: ref.name || "",
        links: ref.links || "",
        description: ref.description || "",
        notes: ref.notes || "",
        admin_notes: ref.admin_notes || "",
      });
    }
    this.modalService.open(this.myModal2);
  }

  updateRef(formRef?: any) {
    // Mark form as submitted to show validation errors
    if (formRef) {
      formRef.submitted = true;
    }

    // Check form validation
    if (this.referenceForm.invalid) {
      this.toastr.error("Please fill all required fields correctly");
      // Mark all fields as touched to show errors
      Object.keys(this.referenceForm.controls).forEach((key) => {
        this.referenceForm.controls[key].markAsTouched();
      });
      return;
    }

    // Get form values
    const formValues = this.referenceForm.value;

    // Build payload - only include changed fields
    const payload: any = {
      name: formValues.name.trim(),
      links: formValues.links.trim(),
      description: formValues.description || "",
      notes: formValues.notes || "",
      admin_notes: formValues.admin_notes || "",
    };

    // Validate URL format
    if (!this.isValidUrl(payload.links)) {
      this.toastr.error("Please enter a valid URL (e.g., https://example.com)");
      return;
    }

    // Only include class_id if it exists
    if (this.reference_model.class_id) {
      payload.class_id = this.reference_model.class_id;
    }

    console.log("Updating reference with payload:", payload);
    console.log("Reference ID:", this.reference_model._id);

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService
      .updateClassReference(this.reference_model._id, payload)
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.statusCode === 200 || res.isSuccess || res.data) {
            this.toastr.success("Reference updated successfully");
            this.modalService.dismissAll();
            // Reset form
            this.referenceForm.reset();
            this.setAndGetClassByStatus(); // refresh list
          } else {
            this.toastr.error(
              res.error || res.message || "Failed to update reference"
            );
          }
        },
        (err: any) => {
          this.spinner.hide();
          console.error("Error updating reference:", err);
          this.toastr.error(
            err.error?.message ||
            err.error?.error ||
            "Failed to update reference. Please try again."
          );
        }
      );
  }

  createRefForClass(row: any) {
    this.selectedClassIdForRef = row._id;
    // Reset form and model
    this.reference_model = {
      _id: "",
      name: "",
      links: "",
      IP: "",
      description: "",
      notes: "",
      admin_notes: "",
    };
    // Reset form values
    if (this.referenceForm) {
      this.referenceForm.reset({
        name: "",
        links: "",
        description: "",
        notes: "",
        admin_notes: "",
      });
    }
    this.modalService.open(this.myModal);
  }

  submitRef(formRef?: any) {
    // Mark form as submitted to show validation errors
    if (formRef) {
      formRef.submitted = true;
    }

    // Check form validation
    if (this.referenceForm.invalid) {
      this.toastr.error("Please fill all required fields correctly");
      // Mark all fields as touched to show errors
      Object.keys(this.referenceForm.controls).forEach((key) => {
        this.referenceForm.controls[key].markAsTouched();
      });
      return;
    }

    // Validate class_id is present
    if (!this.selectedClassIdForRef) {
      this.toastr.error("Class ID is missing. Please try again.");
      return;
    }

    // Get form values
    const formValues = this.referenceForm.value;

    // Validate URL format
    if (!this.isValidUrl(formValues.links.trim())) {
      this.toastr.error("Please enter a valid URL (e.g., https://example.com)");
      return;
    }

    // Build payload - backend will capture IP from request if not provided
    const payload: any = {
      name: formValues.name.trim(),
      links: formValues.links.trim(),
      description: formValues.description || "",
      notes: formValues.notes || "",
      admin_notes: formValues.admin_notes || "",
      class_id: this.selectedClassIdForRef,
      is_deleted: false,
      is_deactivated: false,
    };

    // Only add IP if available (backend can capture from request)
    if (this.reference_model.IP) {
      payload.IP = this.reference_model.IP;
    }

    console.log("Creating reference with payload:", payload);

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService.createReference(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.statusCode === 200 || res.isSuccess) {
          this.toastr.success(res.message || "Reference created successfully");
          this.modalService.dismissAll();
          // Reset form
          this.referenceForm.reset();
          this.reference_model = {
            _id: "",
            name: "",
            links: "",
            IP: "",
            description: "",
            notes: "",
            admin_notes: "",
          };
          this.selectedClassIdForRef = "";
          this.setAndGetClassByStatus(); // Refresh class list
        } else {
          this.toastr.error(
            res.error || res.message || "Failed to create reference"
          );
        }
      },
      (err: any) => {
        this.spinner.hide();
        console.error("Error creating reference:", err);
        this.toastr.error(
          err.error?.message ||
          err.error?.error ||
          "Failed to create reference. Please try again."
        );
      }
    );
  }

  isValidUrl(url: string): boolean {
    try {
      // Add protocol if missing
      let testUrl = url;
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        testUrl = "https://" + url;
      }
      new URL(testUrl);
      return true;
    } catch {
      return false;
    }
  }

  cancelDateEdit() {
    this.editingDateRow = null;
  }

  saveDate(id, row: any, updateBy?: any) {
    const payload = {
      class_id: row._id,
      date: row.date,
    };

    this.apiService.updateClassDate(id, payload, updateBy).subscribe(
      (res) => {
        this.toastr.success("Date updated");
        this.editingDateRow = null;
        this.setAndGetClassByStatus(); // refresh list
      },
      (err) => {
        this.toastr.error("Failed to update date");
      }
    );
  }

  activeClassTab(tab) {
    const activetab = tab;
    this.activeTab = tab;
    if (activetab !== "") {
      this.route.navigate([], {
        relativeTo: this.activerouter,
        queryParams: { status: activetab },
      });
    }
  }
  setAndGetClassByStatus() {
    this.activerouter.queryParams.subscribe((params: any) => {
      this.activeTab = params?.status;
      switch (this.activeTab) {
        case "pattern":
          this.getPatternClassList();
          break;
        case "today":
          this.getClassList(this.activeTab);
          break;
        case "upcoming":
          this.getClassList(this.activeTab);
          break;
        case "past":
          this.getClassList(this.activeTab);
          break;
        default:
          this.getClassList(this.activeTab);
          break;
      }
    });
  }

  ngOnInit() {
    this.initializeReferenceForm();
    this.setAndGetClassByStatus();
    this.getProjectTags();
    this.getAllStudents();
    this.getCourseList();
  }

  initializeReferenceForm() {
    this.referenceForm = this.formBuilder.group({
      name: ["", [Validators.required, Validators.minLength(2)]],
      links: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
          ),
        ],
      ],
      description: [""],
      notes: [""],
      admin_notes: [""],
    });
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getClassList(status) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .getClassList(
        this.page.pageNumber + 1,
        this.limitRef,
        status,
        this.searchVal
      )
      .subscribe((res: any) => {
        this.spinner.hide();
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
  }

  getPatternClassList() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const isDeactivated = this.showDeactivated ? true : false;
    this.apiService
      .getAllPatternClass(
        this.page.pageNumber + 1,
        this.limitRef,
        isDeactivated,
        this.searchVal
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items || [];
          this.page.totalPages = res?.data?.totalCount || 0;

          // Debug: Log project tags to see what's being returned
          if (this.rows && this.rows.length > 0) {
            console.log("Pattern classes loaded. Sample project tags:");
            this.rows.slice(0, 3).forEach((row: any, index: number) => {
              console.log(`Row ${index + 1}:`, {
                title: row.title,
                project_tag: row.project_tag,
                has_project_tag: !!row.project_tag,
                project_tag_name:
                  row.project_tag?.name ||
                  row.project_tag?.displayname ||
                  "N/A",
              });
            });
          }
        },
        (error: any) => {
          this.spinner.hide();
          console.error("Error loading pattern classes:", error);
          this.toastr.error("Failed to load pattern classes");
        }
      );
  }

  toggleDeactivated() {
    // ngModel already updates showDeactivated value
    // Just refresh the list with the new filter
    this.getPatternClassList();
  }

  getFilter() {
    this.page.pageNumber = 0;
    this.setAndGetClassByStatus();
  }

  resetFilter() {
    this.searchVal = "";
    this.page.pageNumber = 0;
    this.setAndGetClassByStatus();
  }

  getAllStudents() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.getAllEnrollStudents(1, 10000).subscribe((res: any) => {
      this.spinner.hide();
      this.student_list = res?.items;
    });
  }

  getCourseList() {
    this.apiService.getCourseList(1, 1000).subscribe((res: any) => {
      this.course_list = res?.data?.items;
    });
  }

  createPatternClass(id) {
    this.class_id = id;
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .createClassbyPaternId(this.class_id)
      .subscribe((res: any) => {
        this.spinner.hide();
        this.setAndGetClassByStatus();
      });
  }

  openPopup(id: string) {
    this.selectedClassId = id;
    this.fromDate = null;
    this.toDate = null;
    this.showDatePopup = true;
  }

  openProjectTagModal(row: any) {
    this.editingProjectRow = row;
    this.selectedProjectTagId = row?.project_tag?._id || null;
    this.modalService.open(this.projectTagModalRef);
  }

  @ViewChild("projectTagModal") projectTagModalRef: any;

  saveSelectedProjectTag(modal: any, updateBy?: any) {
    if (!this.selectedProjectTagId) {
      this.toastr.warning("Please select a Project Tag");
      return;
    }

    const payload = { project_tag: this.selectedProjectTagId };

    console.log("Updating project tag:", {
      classId: this.editingProjectRow._id,
      projectTagId: this.selectedProjectTagId,
      payload: payload,
    });

    this.apiService
      .updateClassProjectTag(this.editingProjectRow._id, payload, updateBy)
      .subscribe(
        (res) => {
          console.log("Project tag update response:", res);
          this.toastr.success("Project Tag Updated");

          // Close modal first
          modal.close();

          // Small delay to ensure backend has processed the update
          setTimeout(() => {
            this.setAndGetClassByStatus(); // refresh table
          }, 500);
        },
        (err) => {
          console.error("Error updating project tag:", err);
          const errorMsg =
            err?.error?.message ||
            err?.error?.error ||
            err?.message ||
            "Update Failed";
          this.toastr.error(errorMsg);
        }
      );
  }

  editTime(row: any) {
    this.editingTimeRow = row._id;
    this.editedStartTime = row.start_time;
    this.editedEndTime = row.end_time;
  }

  cancelTimeEdit() {
    this.editingTimeRow = null;
  }

  openModal(content) {
    // Get IP address if available
    if (!this.reference_model.IP) {
      // You can fetch IP from a service or set it here
      // For now, we'll set it when creating reference
    }
    const modalRef = this.modalService.open(content);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
        // Reset form when modal is dismissed
        if (this.referenceForm) {
          this.referenceForm.reset();
        }
      }
    );
  }

  saveTime(row: any, updatedAt?: any) {
    const payload = {
      start_time: this.editedStartTime,
      end_time: this.editedEndTime,
    };

    this.apiService.updateClassTime(row._id, payload, updatedAt).subscribe(
      (res) => {
        this.toastr.success("Time updated");
        this.editingTimeRow = null;
        this.setAndGetClassByStatus(); // Refresh
      },
      (err) => {
        this.toastr.error("Update failed");
      }
    );
  }

  editNotes(row: any) {
    this.editingNotesRow = row._id;
    this.editedNotes = row.notes;
  }

  cancelNotesEdit() {
    this.editingNotesRow = null;
  }

  saveNotes(row: any, updateBy?: any) {
    const payload = { notes: this.editedNotes };

    this.apiService.updateClassNotes(row._id, payload, updateBy).subscribe(
      (res) => {
        this.toastr.success("Notes updated");
        this.editingNotesRow = null;
        this.setAndGetClassByStatus();
      },
      () => {
        this.toastr.error("Failed to update notes");
      }
    );
  }

  editAdminNotes(row: any) {
    this.editingAdminNotesRow = row._id;
    this.editedAdminNotes = row.admin_notes;
  }

  cancelAdminNotesEdit() {
    this.editingAdminNotesRow = null;
  }

  saveAdminNotes(row: any, updateBy?: any) {
    const payload = { admin_notes: this.editedAdminNotes };

    this.apiService.updateClassAdminNotes(row._id, payload, updateBy).subscribe(
      (res) => {
        this.toastr.success("Admin Notes updated");
        this.editingAdminNotesRow = null;
        this.setAndGetClassByStatus();
      },
      () => {
        this.toastr.error("Failed to update admin notes");
      }
    );
  }

  editZoomLink(row: any) {
    this.editingZoomLinkRow = row._id;
    this.editedZoomLink = row.zoom_link;
  }

  cancelZoomLinkEdit() {
    this.editingZoomLinkRow = null;
  }

  saveZoomLink(row: any, updateBy?: any) {
    const payload = { zoom_link: this.editedZoomLink };

    this.apiService.updateClassZoomLink(row._id, payload, updateBy).subscribe(
      (res) => {
        this.toastr.success("Zoom Link updated");
        this.editingZoomLinkRow = null;
        this.setAndGetClassByStatus();
      },
      () => {
        this.toastr.error("Failed to update zoom link");
      }
    );
  }

  copyZoomLink(zoomLink: string) {
    if (!zoomLink) {
      this.toastr.warning("No zoom link available");
      return;
    }

    // Copy to clipboard
    navigator.clipboard.writeText(zoomLink).then(
      () => {
        this.toastr.success("Zoom link copied to clipboard!");
      },
      (err) => {
        // Fallback method
        const textArea = document.createElement("textarea");
        textArea.value = zoomLink;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.toastr.success("Zoom link copied to clipboard!");
        } catch (e) {
          this.toastr.error("Failed to copy link");
        }
        document.body.removeChild(textArea);
      }
    );
  }

  openPopups() {
    this.fromDate = null;
    this.toDate = null;
    this.showDatePopup1 = true;
  }

  closePopups() {
    this.showDatePopup1 = false;
  }

  closePopup() {
    this.showDatePopup = false;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  confirmPopupForToday(id: string) {
    this.selectedClassId = id;
    const today = new Date();

    this.fromDate = this.formatDate(today);
    this.toDate = this.formatDate(today);
    this.confirmClassPopup();
  }
  confirmPopup() {
    if (!this.fromDate || !this.toDate) {
      this.toastr.warning("Please select both From and To dates");
      return;
    }

    if (!this.selectedClassId) {
      this.toastr.error("Pattern ID is missing");
      return;
    }

    // Validate date range
    const fromDate = moment(this.fromDate);
    const toDate = moment(this.toDate);

    if (toDate.isBefore(fromDate)) {
      this.toastr.error("To date must be after From date");
      return;
    }

    const payload = {
      from: fromDate.format("YYYY-MM-DD"),
      to: toDate.format("YYYY-MM-DD"),
    };

    console.log("Creating classes from pattern:", {
      patternId: this.selectedClassId,
      dateRange: payload,
    });

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService
      .createClassByPaternId(this.selectedClassId, payload)
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.showDatePopup = false;

          // Check for errors in response
          if (res?.error) {
            this.toastr.error(res.error || "Failed to create classes");
            console.error("Error response:", res);
            return;
          }

          // Check success
          const classCount = Array.isArray(res?.data) ? res.data.length : 0;
          if (classCount > 0) {
            this.toastr.success(
              `Successfully created ${classCount} class(es) from pattern`
            );
          } else if (res?.isSuccess || res?.statusCode === 200) {
            this.toastr.success("Classes created successfully");
          } else {
            this.toastr.success("Classes created successfully");
          }

          // Reset dates
          this.fromDate = null;
          this.toDate = null;

          // Refresh table
          this.setAndGetClassByStatus();
        },
        (err: any) => {
          this.spinner.hide();
          this.showDatePopup = false;
          console.error("Error creating classes:", err);
          const errorMsg =
            err?.error?.message ||
            err?.error?.error ||
            err?.message ||
            "Failed to create classes. Please try again.";
          this.toastr.error(errorMsg);
        }
      );
  }
  confirmClassPopup() {
    if (!this.fromDate || !this.toDate) {
      this.toastr.warning("Please select both From and To dates");
      return;
    }

    if (!this.selectedClassId) {
      this.toastr.error("Class ID is missing");
      return;
    }

    // Validate date range
    const fromDate = moment(this.fromDate);
    const toDate = moment(this.toDate);

    if (toDate.isBefore(fromDate)) {
      this.toastr.error("To date must be after From date");
      return;
    }

    const payload = {
      from: fromDate.format("YYYY-MM-DD"),
      to: toDate.format("YYYY-MM-DD"),
    };

    console.log("Generating classes from class ID:", {
      classId: this.selectedClassId,
      dateRange: payload,
    });

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService
      .generateClassByClassId(this.selectedClassId, payload)
      .subscribe(
        (res: any) => {
          console.log("Generate class response:", res);

          // Check for errors
          if (res?.error) {
            this.spinner.hide();
            this.showDatePopup = false;
            this.toastr.error(res.error || "Failed to generate classes");
            return;
          }

          if (res?.isSuccess || res?.statusCode === 200) {
            const classCount = Array.isArray(res?.data) ? res.data.length : 0;
            this.toastr.success(
              classCount > 0
                ? `Successfully created ${classCount} class(es)`
                : "Class created successfully"
            );

            // Start first class if available
            if (res?.data?.[0]?._id) {
              this.startClass(res.data[0]._id);
            }
            console.log("res?.data", res?.data);
            // Reset dates
            this.fromDate = null;
            this.toDate = null;

            this.spinner.hide();
            this.showDatePopup = false;
            this.setAndGetClassByStatus(); // Refresh table
          } else {
            this.spinner.hide();
            this.showDatePopup = false;
            this.toastr.error("Failed to generate classes");
          }
        },
        (err: any) => {
          this.spinner.hide();
          this.showDatePopup = false;
          console.error("Error generating classes:", err);
          const errorMsg =
            err?.error?.message ||
            err?.error?.error ||
            err?.message ||
            "Failed to generate classes. Please try again.";
          this.toastr.error(errorMsg);
        }
      );
  }

  confirmPopups() {
    if (!this.fromDate || !this.toDate) {
      this.toastr.warning("Please select both From and To dates");
      return;
    }

    // Validate date range
    const fromDate = moment(this.fromDate);
    const toDate = moment(this.toDate);

    if (toDate.isBefore(fromDate)) {
      this.toastr.error("To date must be after From date");
      return;
    }

    const payload = {
      from: fromDate.format("YYYY-MM-DD"),
      to: toDate.format("YYYY-MM-DD"),
    };

    console.log("Creating classes from all patterns:", payload);

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService.createClassFromPatern(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.showDatePopup1 = false;

        // Check for errors in response
        if (res?.error) {
          this.toastr.error(
            res.error || "Failed to create classes from patterns"
          );
          console.error("Error response:", res);
          return;
        }

        // Check success
        if (res?.isSuccess || res?.statusCode === 200 || res?.message) {
          const message =
            res?.message || "Classes created successfully from all patterns";
          this.toastr.success(message);
        } else {
          this.toastr.success("Classes created successfully from all patterns");
        }

        // Reset dates
        this.fromDate = null;
        this.toDate = null;

        // Refresh table
        this.setAndGetClassByStatus();
      },
      (err: any) => {
        this.spinner.hide();
        this.showDatePopup1 = false;
        console.error("Error creating classes from patterns:", err);
        const errorMsg =
          err?.error?.message ||
          err?.error?.error ||
          err?.message ||
          "Failed to create classes from patterns. Please try again.";
        this.toastr.error(errorMsg);
      }
    );
  }

  getProjectTags() {
    console.log("Loading project tags - filtering for LIVE and DESK only");
    console.log("Category ID:", this.project_tags_tagcat_id);

    this.apiService.getTagByTagCatgoryId(this.project_tags_tagcat_id).subscribe(
      (res: any) => {
        console.log("🔍 Project tags API response:", res);

        // Handle different response structures
        let allTags: any[] = [];
        if (Array.isArray(res?.data)) {
          allTags = res.data;
        } else if (Array.isArray(res)) {
          allTags = res;
        }

        console.log("📊 Total tags received:", allTags.length);

        if (allTags.length > 0) {
          console.log(
            "🏷️ All tag names:",
            allTags.map((t: any) => ({
              _id: t?._id,
              name: t?.name,
              displayname: t?.displayname,
            }))
          );
        }

        // Filter to show only LIVE and DESK tags (check both name and displayname, case-insensitive)
        const filteredTags = allTags.filter((tag: any) => {
          const name = String(tag?.name || "")
            .toUpperCase()
            .trim();
          const displayname = String(tag?.displayname || "")
            .toUpperCase()
            .trim();
          return (
            name === "LIVE" ||
            name === "DESK" ||
            displayname === "LIVE" ||
            displayname === "DESK"
          );
        });

        if (filteredTags.length > 0) {
          this.project_tags_list = filteredTags;
          console.log(
            "✅ Project tags filtered successfully:",
            this.project_tags_list.length,
            "items (LIVE/DESK only)"
          );
        } else {
          console.warn("⚠️ LIVE or DESK tags not found!");
          if (allTags.length > 0) {
            console.warn(
              "📋 Available tags:",
              allTags
                .map((t: any) => t?.name || t?.displayname)
                .filter(Boolean)
                .join(", ")
            );
            // TEMPORARY: Show all tags so user can see what's available
            console.log(
              "⚠️ TEMPORARY FIX: Showing all available tags in dropdown"
            );
            this.project_tags_list = allTags;
            this.toastr.warning(
              `LIVE/DESK tags not found. Showing all ${allTags.length} available tags. Please create LIVE and DESK tags.`,
              "Tags Missing",
              { timeOut: 6000 }
            );
          } else {
            console.error(
              "❌ No tags found for category:",
              this.project_tags_tagcat_id
            );
            this.project_tags_list = [];
          }
        }
      },
      (error) => {
        console.error("❌ Error loading project tags:", error);
        this.toastr.error("Failed to load project tags");
        this.project_tags_list = [];
      }
    );
  }

  startEditingProjectTag(row: any) {
    this.editingProjectTagRow = row._id;
    this.selectedProjectTag = row?.project_tag || null;
  }

  cancelEditingProjectTag() {
    this.editingProjectTagRow = null;
    this.selectedProjectTag = null;
  }

  saveProjectTag(row: any) {
    const payload = {
      project_tag: this.selectedProjectTag?._id,
    };

    this.apiService.updateClassProjectTag(row._id, payload).subscribe(
      (res) => {
        this.toastr.success("Project tag updated");
        this.editingProjectTagRow = null;
        this.setAndGetClassByStatus(); // refresh data
      },
      (err) => {
        this.toastr.error("Failed to update project tag");
      }
    );
  }

  getActiveDays(schedule: any): string[] {
    if (!schedule) return [];
    return Object.entries(schedule)
      .filter(([_, val]) => val)
      .map(([day]) => day.charAt(0).toUpperCase());
  }

  editClass(row) {
    if (row?.type == "student") {
      this.route.navigate(["classes/add-update-class-byStduent", row?._id]);
    }
    if (row?.type == "batch") {
      this.route.navigate(["classes/add-update-class-byBatch", row?._id]);
    }
  }
  pageChangeData(page: any) {
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset + 1 },
      queryParamsHandling: "merge", // keep existing query params
    });
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    if (this.activeTab === "pattern") {
      this.apiService
        .getAllPatternClass(
          page.offset + 1,
          this.limitRef,
          this.showDeactivated,
          this.searchVal
        )
        .subscribe((res: any) => {
          this.spinner.hide();
          this.setPage(page.offset + 1);
          this.rows = res.data.items;
          this.page.totalPages = res.data.totalCount;
        });
    } else {
      this.apiService
        .getClassList(
          page.offset + 1,
          this.limitRef,
          this.activeTab,
          this.searchVal
        )
        .subscribe((res: any) => {
          this.spinner.hide();
          this.setPage(page.offset + 1);
          this.rows = res.data.items;
          this.page.totalPages = res.data.totalCount;
        });
    }
  }

  deleteClass(id, password) {
    this.apiService.deleteClass(id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Your file has been deleted.",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.setAndGetClassByStatus();
      } else {
        swal.fire({
          icon: "error",
          title: "Error!",
          text: `${res.error}`,
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  }

  getActiveDayInitials(schedule: any): string[] {
    if (!schedule) return [];
    return Object.entries(schedule)
      .filter(([_, isActive]) => isActive)
      .map(([day]) => day.charAt(0).toUpperCase()); // e.g. ['M', 'T']
  }

  getSessionsList(id) {
    this.apiService.getSessionsByCourseId(id).subscribe((res: any) => {
      this.session_list = res?.data;
    });
  }

  getPendingTopics(course, student) {
    this.apiService
      .getPendingTopicByUserId(course, student, "", "student")
      .subscribe((res: any) => {
        this.topic_list = res?.data;
        this.select_topic = this.topic_list.map((item) => item.topic_id);
        let topic = this.topic_list.map((item) => item.topic_name);
        this.student_obj.topic_id.push(topic);
      });
  }

  getEnrollmentByStudent(id) {
    if (id) {
      this.apiService.getEnrolmentByUserId(id).subscribe((res: any) => {
        this.enrollment_list = res?.data?.map((item) => item);
        this.select_enrollment = this.enrollment_list[0]._id;
        this.select_course = this.enrollment_list[0].course_id;
        if (this.select_course) {
          this.getPendingTopics(this.select_course, this.select_student);
          this.getSessionsList(this.select_course);
        }
      });
    }
  }

  getStudentId(event) {
    this.student_obj.student_id = event.name;
    this.select_student;
    this.getEnrollmentByStudent(this.select_student);
  }

  // ================== Delete Alert ========================
  Delete(id: any) {
    this.class_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.deleteClass(this.class_id, result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  viewTopics(data: any) {
    const students = data.students;
    const modalRef = this.modalService.open(ViewTopicsComponent, {
      size: "lg", // You can adjust size (sm, md, lg, etc.)
    });

    // Pass data to the modal component if needed
    modalRef.componentInstance.students = students;
  }
  getTypeId(event) {
    this.select_classType = event.name;
    this.getClassList(this.activeTab);
  }
  startClass(id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    if (id) {
      this.apiService.createStudentAttendence(id).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.spinner.hide();
          this.toastr.success("student attendence created successfully");
          this.setAndGetClassByStatus();
        } else {
          this.spinner.hide();
          this.toastr.error(res?.error);
        }
      });
    }
  }

  isClassIdSet(): boolean {
    return this.class_id;
  }

  getEnrollmentId(event) {
    this.select_enrollment;
  }

  getCourseId(event) {
    this.select_course;
    this.getPendingTopics(this.select_course, this.select_student);
  }

  getRadioValue(event) {
    this.radio_button = event.target.value;
  }

  getSessionId(event) {
    this.select_session;
    let topic = this.select_session.topic_id.map((item) => item._id);
    let topicname = this.select_session.topic_id.map((item) => item.name);
    this.student_obj.topic_id.push(topicname);
    this.select_topic = topic;
  }

  getTopicId(event) {
    this.select_topic;
    if (event) {
      let topic = event.map((item) => item.topic_name);
      this.student_obj.topic_id.push(topic);
    }
  }

  addStudentPopup(content) {
    const modalOptions: NgbModalOptions = {
      size: "lg",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => { }
    );
  }

  isNewClass(): boolean {
    return !this.class_id;
  }

  addStudent() {
    console.log("addStudent called");
    let session = this.select_session ? this.select_session._id : "";
    let obj = {
      student_id: this.select_student,
      enrolment_id: this.select_enrollment,
      topic_id: this.select_topic,
      course_id: this.select_course,
      ...(session && { session_id: session }),
    };
    this.class_model.students.push(obj);
    this.students_array.push(this.student_obj);
    this.student_obj = {
      student_id: "",
      enrollment_id: "",
      course_id: "",
      session_id: "",
      topic_id: [],
    };
    this.select_student = null;
    this.select_enrollment = null;
    this.select_topic = null;
    this.select_session = null;
    this.select_course = null;
    this.isStudentSubmit = true;
  }

  getStudentNames(row: any): string {
    if (!row?.students?.length) return "";
    return row.students
      .map((s) => s?.student_info?.name)
      .filter((n) => !!n)
      .join(", ");
  }

  updateStudent(updateBy?: any) {
    let body = {
      students: [
        {
          student_id: this.select_student,
          enrolment_id: this.select_enrollment,
          topic_id: this.select_topic,
          session_id: this.select_session,
          course_id: this.select_course,
        },
      ],
    };
    console.log("body", body);
    console.log("this.class_id", this.class_id);
    console.log("this.select_student", this.select_student);
    if (this.class_id) {
      this.apiService
        .updateMultipleClassStudents(this.class_id, body, updateBy)
        .subscribe((res: any) => {
          if (res?.isSuccess) {
            this.modalService.dismissAll();
            this.toastr.success("Class update successfully");
            // this.classGetById(this.class_id);
            this.setAndGetClassByStatus(); // refresh data
          } else this.toastr.error(res?.error);
        });
    }
  }

  classGetById(id) {
    this.apiService.getClassById(id).subscribe((res: any) => {
      this.class_model = res?.data[0];
      let date: any = moment(res?.data[0]?.date).format("YYYY-MM-DD");
      this.class_model.date = date;
      this.class_model.title = res?.data[0]?.title;
      this.class_model.start_time = res?.data[0]?.start_time;
      this.class_model.end_time = res?.data[0]?.end_time;
      this.class_model.notes = res?.data[0]?.notes;
      this.class_model.admin_notes = res?.data[0]?.admin_notes;
      this.class_model.status = res?.data[0]?.status;
      this.class_model.instructor = res?.data[0]?.instructor?._id;
      this.class_model.students = res?.data[0]?.students;
      if (this.class_model?.references?.length > 0) {
        this.referenceList = this.class_model?.references?.map((item) => item);
        this.selectedRef = this.referenceList?.map((item) => item?._id);
        // this.jobModel.references=this.selectedRef
      }
    });
  }

  openStudentModal(row: any) {
    this.class_id = row._id;

    // Preload existing student data for the first student in the class (if any)
    const stu = row.students && row.students.length ? row.students[0] : null;

    if (stu) {
      // Support both old shape (student_id, enrolment_id, ...) and new aggregated shape (student_info, enrolment_info, ...)
      this.select_student =
        stu.student_id?._id || stu.student_info?._id || stu.student_id || null;

      this.select_enrollment =
        stu.enrolment_id?._id ||
        stu.enrolment_info?._id ||
        stu.enrolment_id ||
        null;

      this.select_course =
        stu.course_id?._id || stu.course_info?._id || stu.course_id || null;

      this.select_session =
        stu.session_id?._id || stu.session_info?._id || stu.session_id || null;

      // Topics can be array of ids or array of objects; normalise to array of ids
      const topicSource = stu.topic_info || stu.topic_id || [];
      this.select_topic = Array.isArray(topicSource)
        ? topicSource.map((t: any) => (t && t._id ? t._id : t))
        : [];
    } else {
      // No students yet; keep selects empty
      this.select_student = null;
      this.select_enrollment = null;
      this.select_course = null;
      this.select_session = null;
      this.select_topic = [];
    }

    this.modalService.open(this.studentModal);
  }

  deactivatePattern(id: string) {
    swal
      .fire({
        title: "Are you sure?",
        text: "Do you want to deactivate this pattern class?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, deactivate it!",
        cancelButtonText: "No, cancel",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          const payload = { isDeactivated: true };
          this.apiService.updateClass(id, payload).subscribe(
            (res: any) => {
              this.spinner.hide();
              if (res.statusCode === 200) {
                swal.fire({
                  icon: "success",
                  title: "Deactivated!",
                  text: "Pattern class has been deactivated.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.setAndGetClassByStatus();
              } else {
                swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: res.error || "Failed to deactivate pattern class",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
            },
            (error) => {
              this.spinner.hide();
              swal.fire({
                icon: "error",
                title: "Error!",
                text: "Failed to deactivate pattern class",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
          );
        }
      });
  }

  activatePattern(id: string) {
    swal
      .fire({
        title: "Are you sure?",
        text: "Do you want to activate this pattern class?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, activate it!",
        cancelButtonText: "No, cancel",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-secondary",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          const payload = { isDeactivated: false };
          this.apiService.updateClass(id, payload).subscribe(
            (res: any) => {
              this.spinner.hide();
              if (res.statusCode === 200) {
                swal.fire({
                  icon: "success",
                  title: "Activated!",
                  text: "Pattern class has been activated.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.setAndGetClassByStatus();
              } else {
                swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: res.error || "Failed to activate pattern class",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
            },
            (error) => {
              this.spinner.hide();
              swal.fire({
                icon: "error",
                title: "Error!",
                text: "Failed to activate pattern class",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
          );
        }
      });
  }

  deleteAllUpcomingClasses() {
    swal
      .fire({
        title: "Are you sure?",
        text: "Do you want to delete all upcoming classes? This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          this.apiService.deleteAllUpcomingClasses().subscribe(
            (res: any) => {
              this.spinner.hide();
              if (res.statusCode === 200 || res.isSuccess) {
                swal.fire({
                  icon: "success",
                  title: "Deleted!",
                  text: "All upcoming classes have been deleted.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.setAndGetClassByStatus();
              } else {
                swal.fire({
                  icon: "error",
                  title: "Error!",
                  text:
                    res.error ||
                    res.message ||
                    "Failed to delete upcoming classes",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
            },
            (error) => {
              this.spinner.hide();
              swal.fire({
                icon: "error",
                title: "Error!",
                text:
                  error?.error?.message ||
                  error?.error?.error ||
                  "Failed to delete upcoming classes",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
          );
        }
      });
  }
}
